import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-3c0ca9ec"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "popover-content"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_product_score = _resolveComponent("product-score");
  const _component_app_icon = _resolveComponent("app-icon");
  const _component_app_popover = _resolveComponent("app-popover");
  const _component_app_td = _resolveComponent("app-td");
  return _openBlock(), _createBlock(_component_app_td, {
    stickyColumn: "",
    align: "center",
    class: "border-table-row stick-to-right",
    style: _normalizeStyle({
      right: $props.pushModal ? '79px' : '115px'
    })
  }, {
    default: _withCtx(() => [$props.item.show_omny_validation_status ? (_openBlock(), _createBlock(_component_product_score, {
      key: 0,
      size: 20,
      score: $props.item.statusOmnyScore.score,
      color: $props.item.statusOmnyScore.status == 'success' ? '#22863d' : $props.item.statusOmnyScore.status == 'warning' ? '#d7aa0f' : '#e7747a',
      id: `${$props.item.content_id}-score-omny`
    }, null, 8, ["score", "color", "id"])) : _createCommentVNode("", true), $props.item.show_omny_validation_status ? (_openBlock(), _createBlock(_component_app_popover, {
      key: 1,
      target: `${$props.item.content_id}-score-omny`,
      "auto-width": "",
      placement: "left",
      "custom-class": "seo-popover"
    }, {
      default: _withCtx(() => [_createElementVNode("div", _hoisted_1, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.item.statusResultOmnyScore, result => {
        return _openBlock(), _createElementBlock("div", {
          class: "status-item",
          key: result.text
        }, [_createVNode(_component_app_icon, {
          size: "16",
          icon: result.status == 'success' ? 'check-v2' : result.status == 'warning' ? 'product-score-warning' : 'product-score-bad',
          color: result.status == 'success' ? '#22863d' : result.status == 'warning' ? '#d7aa0f' : '#ffffff'
        }, null, 8, ["icon", "color"]), _createElementVNode("span", null, _toDisplayString(result.text), 1)]);
      }), 128))])]),
      _: 1
    }, 8, ["target"])) : _createCommentVNode("", true)]),
    _: 1
  }, 8, ["style"]);
}